module.exports = __webpack_public_path__ + "media/assets/instagram-a75ff1fa14f862d5070dabe7de8af425.svg";